export default {
  root: {
    name: '/admin/dashboard',
    displayName: 'Home'
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard'
    },
    {
      name: 'usuarios',
      displayName: 'Usuários',
      disabled: true,
      children: [
        {
          name: 'listagem-usuarios',
          displayName: 'Listar Usuários',
          children: [
            {
              name: 'editar-usuario',
              displayName: 'Editar Usuário'
            },
          ]
        },
        {
          name: 'novo-usuario',
          displayName: 'Novo Usuário'
        },
        {
          name: 'permissoes',
          displayName: 'Permissões'
        },
      ]
    },
    {
      name: 'veiculos',
      displayName: 'Veículos',
      disabled: true,
      children: [
        {
          name: 'listagem-veiculos',
          displayName: 'Listar Veículos',
        },
        // {
        //   name: 'novo-veiculo',
        //   displayName: 'Novo Veículo'
        // },
        // {
        //   name: 'editar-veiculo',
        //   displayName: 'Editar Veículo'
        // },
      ]
    },
    {
      name: 'instrutores',
      displayName: 'Instrutores',
      disabled: true,
      children: [
        {
          name: 'listagem-instrutores',
          displayName: 'Listar Instrutores',
          children: [
            {
              name: 'editar-instrutor',
              displayName: 'Editar Instrutor'
            },
          ]
        },
        {
          name: 'novo-instrutor',
          displayName: 'Novo Instrutor'
        },
        {
          name: 'dash-instrutor',
          displayName: 'Listar Aulas Instrutor'
        }
      ]
    },
    {
      name: 'alunos',
      displayName: 'Alunos',
      disabled: true,
      children: [
        {
          name: 'listagem-alunos',
          displayName: 'Listar Alunos',
        },
        {
          name: 'listagem-pacientes',
          displayName: 'Pacientes',
        },
        {
          name: 'novo-aluno-basic',
          displayName: 'Novo aluno'
        },
        {
          name: 'novo-aluno-psico',
          displayName: 'Novo aluno Psicotécnico'
        },
        {
          name: 'editar-aluno',
          displayName: 'Editar aluno'
        },
        {
          name: 'editar-paciente',
          displayName: 'Editar Paciente'
        },
      ]
    },
    {
      name: 'aulas-praticas',
      displayName: 'Aulas Práticas',
      disabled: true,
      children: [
        {
          name: 'processo-agendamento',
          displayName: 'Consulta Carga Horária',
        },
        {
          name: 'processo-index',
          displayName: 'Buscar Aulas Práticas',
        },
        {
          name: 'agendar-pratica',
          displayName: 'Agendar Aula Prática',
        },
        {
          name: 'aulas-agendadas',
          displayName: 'Listar Aulas Agendadas',
        },
        {
          name: 'aulas-realizadas',
          displayName: 'Listar Aulas Realizadas',
        },
      ]
    },
    {
      name: 'aulas-teoricas',
      displayName: 'Aulas Teóricas',
      disabled: true,
      children: [
        {
          name: 'carga-horaria-teorica',
          displayName: 'Consulta Carga Horária',
        },
        {
          name: 'listagem-turmas',
          displayName: 'Listar Turmas',
        },
        {
          name: 'aulas-presenciais',
          displayName: 'Aulas Presenciais',
        },
      ]
    },
    {
      name: 'turmas',
      displayName: 'Turmas',
      disabled: true,
      children: [
        // {
        //   name: 'listagem-turmas',
        //   displayName: 'Turmas',
        // },
        {
          name: 'nova-turma',
          displayName: 'Nova Turma'
        },
        {
          name: 'editar-turma',
          displayName: 'Editar Turma'
        },
        {
          name: 'aula-teorica',
          displayName: 'Aula Teórica'
        },
      ]
    },
    {
      name: 'agendamento',
      displayName: 'Agendamento',
      disabled: true,
      children: [
        {
          name: 'aulas-agenda',
          displayName: 'Agenda',
        },
        // {
        //   name: 'agendar-pratica',
        //   displayName: 'Agendar',
        // },
        // {
        //   name: 'aulas-agendadas',
        //   displayName: 'Aulas Agendadas'
        // },
        // {
        //   name: 'aulas-realizadas',
        //   displayName: 'Aulas Realizadas'
        // },
        {
          name: 'planos-praticos',
          displayName: 'Planos Práticos'
        },
      ]
    },
    {
      name: 'monitoramento',
      displayName: 'Monitoramento',
      disabled: true,
      children: [
        // {
        //   name: 'monitoramento-pratica',
        //   displayName: 'Monitorar aulas práticas',
        // },
        {
          name: 'monitoramento-teorica',
          displayName: 'Monitorar aulas teóricas'
        },
        {
          name: 'monitoramento-virtual',
          displayName: 'Monitorar aulas virtuais'
        },
        {
          name: 'relatorio-monitoramento',
          displayName: 'Relatórios'
        },
        {
          name: 'alertas',
          displayName: 'Alertas'
        },
      ]
    },
    {
      name: 'faturas',
      displayName: 'Faturas',
      disabled: true,
      children: [
        {
          name: 'faturas-praticas',
          displayName: 'Faturas Práticas',
        },
        {
          name: 'faturas-teoricas',
          displayName: 'Faturas Teóricas'
        },
        {
          name: 'faturas-index',
          displayName: 'Faturas e Boletos'
        },
        {
          name: 'importarFaturas',
          displayName: 'Importar Faturas'
        }
      ]
    },
    {
      name: 'Comissao',
      displayName: 'Comissão',
      disabled: true,
      children: [
        {
          name: 'relatorio-consultor',
          displayName: 'Relatório Consultor',
        }
      ]
    },
    {
      name: 'relatorios',
      displayName: 'Relatórios',
      disabled: true,
      children: [
        {
          name: 'geral',
          displayName: 'Relatórios Gerais',
        },
        {
          name: 'acoes-usuarios',
          displayName: 'Ações de Usuários',
        },
        {
          name: 'faturamento',
          displayName: 'Faturamento',
        },
      ]
    },
    {
      name: 'cfc',
      displayName: 'Centros de Formação de Condutores',
      disabled: true
    },
    {
      name: 'salas',
      displayName: 'Salas',
      disabled: true,
      children: [
        {
          name: 'listagem-salas',
          displayName: 'Salas',
        },
        {
          name: 'nova-sala',
          displayName: 'Nova Sala'
        },
        {
          name: 'editar-sala',
          displayName: 'Editar Sala'
        },
      ]
    },
    {
      name: 'configuracoes',
      displayName: 'Configurações'
    },
    {
      name: 'cameras',
      displayName: 'Câmeras',
      disabled: true,
      children: [
        {
          name: 'listagem-cameras',
          displayName: 'Câmeras',
        },
        {
          name: 'nova-cam',
          displayName: 'Nova Câmera'
        },
        {
          name: 'editar-camera',
          displayName: 'Editar Câmera'
        },
      ]
    },
  ]
}
